import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Bell, Calendar, CheckSquare, Users } from 'lucide-react';
import { toast } from 'sonner';
import { formatDate } from '../utils/helpers';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadNotifications(); }, []);

  const loadNotifications = async () => {
    try {
      const { data } = await axios.get(`${API}/notifications`, { withCredentials: true });
      setNotifications(data);
    } catch (error) { toast.error('Failed to load notifications'); } finally { setLoading(false); }
  };

  const getIcon = (type) => {
    const icons = { renewal: Calendar, task: CheckSquare, lead: Users, system: Bell };
    const Icon = icons[type] || Bell;
    return <Icon className="h-5 w-5" />;
  };

  if (loading) return <div className="flex items-center justify-center h-96"><div className="spinner"></div></div>;

  return (
    <div className="space-y-6" data-testid="notifications-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight" style={{ fontFamily: 'Manrope' }}>Notifications</h1>
        <p className="text-slate-600 mt-1">Stay updated on your business activities</p>
      </div>

      <Card className="border-slate-200 shadow-sm">
        <CardHeader><CardTitle style={{ fontFamily: 'Manrope' }}>Recent Notifications ({notifications.length})</CardTitle></CardHeader>
        <CardContent>
          {notifications.length === 0 ? (
            <div className="text-center py-12">
              <Bell className="h-12 w-12 text-slate-300 mx-auto mb-4" />
              <p className="text-slate-500">No notifications yet</p>
              <p className="text-sm text-slate-400 mt-1">You'll see renewal reminders, task alerts, and system updates here</p>
            </div>
          ) : (
            <div className="space-y-3">
              {notifications.map((n) => (
                <div key={n.notification_id} className={`p-4 rounded-lg border ${n.read ? 'bg-slate-50 border-slate-200' : 'bg-blue-50 border-blue-200'}`}>
                  <div className="flex items-start">
                    <div className={`p-2 rounded-lg mr-3 ${n.read ? 'bg-slate-200' : 'bg-blue-200'}`}>{getIcon(n.type)}</div>
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-1">
                        <p className="font-medium">{n.title}</p>
                        {!n.read && <Badge className="bg-blue-800 text-white">New</Badge>}
                      </div>
                      <p className="text-sm text-slate-600">{n.message}</p>
                      <p className="text-xs text-slate-500 mt-1">{formatDate(n.created_at)}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default Notifications;
